// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/full_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/banner_img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/gift_of_travel.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/travelll_bggg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/member_include.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/tick.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/follow_up.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/faq_banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/tools_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full_bg{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-attachment: fixed;
    background-position: center top;
    background-size: cover;
}


.banner_partts{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
    background-attachment: fixed;
    padding: 30px 0;
    width: 100%;
    background-size: cover;
}

.banner_partts h1{
    font-size: 72px;
    color: #fff;
    line-height: 1.3em;
    text-align: center;
    font-family: 'Montserrat', sans-serif !important;
    
    margin-bottom: 0px;
}
.banner_partts h1 strong{
    display: block;
    font-family: 'Montserrat', sans-serif !important;
}
.sub_heading{
    padding-top: 42px;
    max-width: 990px;
    margin: 0 auto;
    width: 100%;
}
.sub_heading h2{
    font-size: 46px;
    font-weight: 400;
    color: #fff;
    text-shadow: 1px 1px 3px rgba(0,0,0,.5);
    text-align: center;
    margin-bottom: 0px;
    font-family: 'Montserrat', sans-serif !important;
}

.cup_coffee{
    display: block;
}

.free_trial_butt{
    height: 50px;
    padding: 0 40px;
    line-height: 50px;
    background: #107faa;
    display: inline-block;
    font-family: 'Abel', sans-serif !important;
    color: #fff;
    font-size: 26px;
    font-weight: 700;
    margin-top: 0;
    text-shadow: 0 0 0 transparent;
    animation: bounce 1.5s infinite;
    animation-timing-function: ease-in;
    transition: .2s;
    font-family: 'Montserrat', sans-serif !important;
}

.free_trial{
    text-align: center;
    margin-top: 30px;
}

.free_trial a:hover{
    color: #fff;
    text-decoration: none;
}

@keyframes bounce{
    15% {
        box-shadow: 0 0 0 0 transparent;
        transform: translateY(0);
    }
    35% {
        box-shadow: 0 8px 5px -5px #00000040;
        transform: translateY(-35%);
    }
    45% {
        box-shadow: 0 0 0 0 transparent;
        transform: translateY(0);
    }
    55% {
        box-shadow: 0 5px 4px -4px #00000040;
        transform: translateY(-20%);
    }
    70% {
        box-shadow: 0 0 0 0 transparent;
        transform: translateY(0);
    }
    80% {
        box-shadow: 0 4px 3px -3px #00000040;
        transform: translateY(-10%);
    }
    90% {
        box-shadow: 0 0 0 0 transparent;
        transform: translateY(0);
    }
    95% {
        box-shadow: 0 2px 3px -3px #00000040;
        transform: translateY(-2%);
    }
    99% {
        box-shadow: 0 0 0 0 transparent;
        transform: translateY(0);
    }
    100% {
        box-shadow: 0 0 0 0 transparent;
        transform: translateY(0);
    }
}

.free_trials_lead{
    display: flex;
    flex-wrap: wrap;
    margin: 30px -10px;
}

.lead_inner{
    max-width: calc(100%/3);
    width: 100%;
    text-align: center;
    padding: 0 10px;
}
.lead_inner img{
    width: 200px;
    height: 200px;
}
.lead_heading{
    margin-top: 30px;
    background: rgba(45, 45, 45, 0.5);
    width: 100%;
    padding: 5px 0;
}
.lead_heading h2{
    font-size: 32px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 0px;
    font-family: 'Montserrat', sans-serif !important;
}
.lead_para{
    background-color: rgba(45, 45, 45, 0.5);
    padding: 5px;
    margin-top: 10px;
}

.lead_para p{
    font-family: 'Abel', sans-serif !important;
    color: #fff;
    font-size: 22px;
    margin-bottom: 0px;
    /* font-family: 'Montserrat', sans-serif !important; */
}

.tripvalet_logo{
    text-align: center;
}

.tripvalet_logo img{
    width: 200px;
}

.vacation_incentive{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center top;
    background-size: cover;
    padding: 30px 0;
}

.vacation_inner h2{
    text-align: center;
    font-size: 32px;
    color: #fff;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif !important;
}

.vacation_player iframe{
    width: 100% !important;;
    height: 100% !important;;
}

/* .vacation_player > div{
    width: 100% !important;
} */


.gift_of_travel{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
    background-size: cover;
    background-position: center top;
    background-attachment: fixed;
    padding: 100px 0;
}

.travel_container{
    background: rgba(0, 0, 0, 0.5);
    padding: 5px 0;
    width: 100%;
    margin-bottom: 50px;
}
.travel_container2{
    background: rgba(0, 0, 0, 0.5);
    padding: 5px 60px;
    width: 100%;
}
.travel_container h2, .travel_container2 h2{
    text-align: center;
    color: #fff;
    font-weight: 700;
    font-size: 42px;
    margin-bottom: 0px;
    font-family: 'Montserrat', sans-serif !important;
}

.travel_container p{
    font-size: 23px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    margin-bottom: 0px;
    font-family: 'Montserrat', sans-serif !important;
}
.travel_cont_para p{
    font-size: 23px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 0px;
    text-align: center;
    font-family: 'Montserrat', sans-serif !important;
}

.every_one_travel{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) repeat;
    background-size: cover;
    background-position: 50%;
    background-attachment: fixed;
    padding: 60px 0;
}

.every_ravel_inner h2{
    font-weight: 700;
    color: #fff;
    font-size: 58px;
    text-align: center;
    margin-bottom: 40px;
    font-family: 'Montserrat', sans-serif !important;
}
.free_trial_butt.color2{
    background: rgb(11, 92, 123);
}
.tvi_member_include{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
    background-size: cover;
    background-position: center center;
    padding: 30px 0;
}

.tvi_member_include_white_bg{
    background: #fff;
    padding: 20px 25px;
}

.tvi_member_include_white_bg h2{
    text-align: center;
    color: #000;
    font-weight: 700;
    font-size: 32px;
    font-family: 'Montserrat', sans-serif !important;
}

.tvi_member_para p{
    font-size: 23px;
    line-height: 32px;
    text-align: center;
    color: #000;
    font-family: 'Montserrat', sans-serif !important;
}

.tvi_member_para p span{
    display: block;
    font-family: 'Montserrat', sans-serif !important;
}

.tvi_member_border_cont{
    border: 2px solid #000;
    padding: 20px;
    text-align: left;
}

.tvi_member_border_cont ul{
    padding-left: 0px;
    margin-bottom: 0px;
}

.tvi_member_border_cont ul li{
    list-style: none;
    position: relative;
    padding-left: 40px;
}
.tvi_member_border_cont ul li, .tvi_member_border_cont ul li p{
    font-size: 20px;
    color: #000;
    font-family: 'Montserrat', sans-serif !important;
}
.tvi_member_border_cont ul li p{
    margin-bottom: 0px;
    font-family: 'Montserrat', sans-serif !important;
}
.tvi_member_border_cont ul li p{}
.tvi_member_border_cont ul li:before{
    position: absolute;
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat;
    width: 32px;
    height: 32px;
    left: 0;
    top: 0;
}

.monthly_price{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
}

.price_inner{
    padding: 0 10px;
    max-width: calc(100%/3);
    width: 100%;
    margin-top: 15px;
}

.price_inner_inner{
    border: 2px solid #fff;
    padding: 20px;
}

.price_inner_inner h2{
    font-size: 32px;
    color: #fff;
    font-weight: 700;
    text-align: center;
    margin-bottom: 9px;
    font-family: 'Montserrat', sans-serif !important;
}
.price_inner_inner h3{
    font-size: 32px;
    color: #fff;
    font-weight: 700;
    text-align: center;
    margin-bottom: 0px;
    font-family: 'Montserrat', sans-serif !important;
}

.price_inner_heading{
    min-height: 115px;
}

.price_button{
    margin-top:30px;
    text-align: center;
}

.get_started_but{
    font-family: 'Abel', sans-serif !important;
    color: rgb(16, 127, 170);
    background: #fff;
    padding: 0;
    font-weight: 700;
    height: 60px;
    line-height: 60px;
    font-size: 26px;
    display: block;
    width: 100%;
}


.price_inner_heading p{
    font-family: 'Abel', sans-serif !important;
    color: #fff;
    font-size: 14px;
    text-align: center;
    margin-bottom: 0px;
}

.monthly_price{
    margin-top: 20px;
}


.follow_up_inner{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat;
    background-size: cover;
    background-position: center top;
    padding: 30px;
}


.follow_up_inner h2{
    text-align: center;
    color: #fff;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.3em;
    margin-bottom: 35px;
    font-family: 'Montserrat', sans-serif !important;
}

.follow_up_inner h3{
    font-weight: 700;
    font-size: 24px;
    color: #FFF;
    margin: 40px 0 30px 0;
    text-align: center;
    font-family: 'Montserrat', sans-serif !important;
}

.testimonial_inner{
    margin-top: 40px;
}

.test_inner_imgg{
    margin-bottom: 40px;
}

.testimonial_inner2{
    margin-top: 40px;
}

.faq_inner{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
    background-attachment: fixed;
    background-position: 50%;
    background-size: cover;
    padding: 30px;
    margin-top: 40px;
}


.faq_hading{
    text-align: center;
}

.faq_hading h2{
    padding: 0 40px;
    display: inline-block;
    color: rgb(16, 127, 170);
    font-size: 38px;
    font-weight: 700;
    border-bottom: 4px solid rgb(16, 127, 170);
    padding-bottom: 10px;
    font-family: 'Montserrat', sans-serif !important;
}

.faq_inner_section{
    margin-top: 40px;
}
.faq_content{
    margin-bottom: 30px;
}

.question_faq{
    font-size: 23px;
    font-weight: 500;
    color: rgb(43, 143, 192);
    text-align: center;
    line-height: 32px;
    margin-bottom: 15px;
}


.answer_faq{
    font-size: 20px;
    font-family: 'Abel', sans-serif !important;
    color: #fff;
    line-height: 30px;
    text-align: center;
}
.answer_faq span{
    text-transform: uppercase;
}

.faq_bulb{
    text-align: center;
    margin-top: 30px;
}
.faq_bulb img{
    width: 80px;
}

.get_started_div{
    text-align: center;
}

.ready_started{
    font-family: 'Abel', sans-serif !important;
    background-color: rgb(16, 127, 170);
    color: #fff;
    font-size: 40px;
    font-weight: 700;
    height: 80px;
    line-height: 80px;
    padding: 0 35px;
    display: inline-block;
    border: 0px;
}

.unlock_tools{
    margin-top: 30px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
    background-size: cover;
    background-position: center top;
    padding: 60px 0;
}

.unlock_tools_inner h2{
    font-size: 48px;
    font-weight: 700;
    color: #000;
    text-align: center;
    line-height: 56px;
    font-family: 'Montserrat', sans-serif !important;
}

.unlock_tools_cont p{
    font-size: 32px;
    font-weight: 500;
    color: #fff;
    line-height: 46px;
    text-align: center;
    margin-bottom: 50px;
    font-family: 'Montserrat', sans-serif !important;
}

.business_heading{
    display: block;
}

.unlock_tools_cont{
    margin-top: 30px;
}

.designed_a_z{
    padding: 60px 0;
}

.designed h2{
    font-size: 52px;
    font-weight: 700;
    color: #000;
    text-align: center;
    font-family: 'Montserrat', sans-serif !important;
}

.designed h2 span{
    color: rgb(16, 127, 170);
    line-height: 1.3em;
    display: block;
    font-family: 'Montserrat', sans-serif !important;
}

.designed h5{
    text-align: center;
    font-size: 23px;
    color: #000;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif !important;
}

.starter_level{
    display: flex;
    flex-wrap: wrap;
    margin: 40px -15px 50px -15px;
}

.starter_inner_level{
    max-width: calc(100%/3);
    width: 100%;
    padding: 0 15px;
}

.starter_inner_inner_level img{
    width: 300px;
    margin: 20px auto;
    display: block;
}

.starter_inner_level h2{
    text-align: center;
    font-size: 23px;
    font-weight: 500;
    color: #000;
    text-transform: uppercase;
    font-family: 'Montserrat', sans-serif !important;
}

.starter_inner_level p{
    font-size: 16px;
    font-family: 'Abel', sans-serif !important;
    color: #000;
    text-align: center;
    margin-top: 30px;
    padding: 0 20px;
}


.training_content h2{
    font-size: 32px;
    color: rgb(45, 45, 45);
    text-align: center;
    line-height: 1.3em;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif !important;
}


.training_content h3{
    font-size: 32px;
    font-weight: 700;
    color: #000;
    text-align: center;
    margin-top: 15px;
    font-family: 'Montserrat', sans-serif !important;
}

.footer_partts{
    background: rgb(136, 136, 136);
    padding: 20px 0;
}

.footer_inner_logo img{
    width: 200px;
}

.footer_right_text{
    max-width: 220px;
    width: 100%;
}

.footer_right_text p{
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-family: 'Abel', sans-serif !important;
}
.privacy_div a{
    font-size: 11px;
    color: #fff;
    padding: 0 8px;
    position: relative;
}
.privacy_div a:before{
    content: "|";
    position: absolute;
    right: 0;
    top: 0;
    color: #fff;
}

.privacy_div a:last-child:before{
    content: none;
}

@media screen and (max-width:576px){
    .footer_partts{
        text-align: center;
    }
    .footer_right_text{
        max-width: 100%;
    }
}


@media screen and (max-width:992px){
    .banner_partts h1{
        font-size: 50px;
    }
    .sub_heading h2{
        font-size: 40px;
        padding: 0 40px;
    }
    .free_trials_lead{
        justify-content: center;
        align-items: center;
    }
    .free_trials_lead .lead_inner{
        max-width: calc(100%/2);
    }
    .lead_inner img {
        width: 120px;
        height: 120px;
    }

    .lead_inner{
        margin-bottom: 30px;
    }
    .vacation_inner h2{
        font-size: 24px;
    }

    .vacation_player > div{
        height: 300px !important;
    }
    .gift_of_travel{
        padding: 40px 0;
    }
    .travel_container h2, .travel_container2 h2{
        font-size: 32px;
    }
    .travel_container p{
        font-size: 18px;
    }
    .travel_cont_para p{
        font-size: 18px;
        line-height: 24px;
    }

    .every_one_travel{
        padding: 20px 0;
    }
    .every_ravel_inner h2{
        font-size: 46px;
    }

    .tvi_member_include_white_bg h2{
        font-size: 28px;
    }

    .tvi_member_para p{
        font-size: 18px;
    }

    .tvi_member_border_cont ul li, .tvi_member_border_cont ul li p{
        font-size: 16px;
    line-height: 28px;
    }
    .price_inner{
        max-width: calc(100%/2);
        margin-bottom: 25px;
    }
    .follow_up_inner h2{
        font-size: 26px;
    }

    .unlock_tools_inner h2{
        font-size: 32px;
        line-height: 42px;
    }
    .unlock_tools_cont p{
        font-size: 28px;
        line-height: 42px;
    }

    .designed h2{
        font-size: 32px;
    }

    .starter_inner_level{
        max-width: calc(100%/2);
    }
    .starter_level{
        justify-content: center;
        align-items: flex-start;
    }

    .training_content h2, .training_content h3{
        font-size: 28px;
    }
}


@media screen and (max-width:576px){
    .ready_started{
        font-size: 28px;
        height: 60px;
        line-height: 60px;
    }
    .unlock_tools_cont p {
        font-size: 24px;
        line-height: 36px;
    }
    .starter_inner_inner_level img{
        width: 200px;
    }
    .designed h2 {
        font-size: 28px;
    }
    
    .designed_a_z{
        padding: 30px 0 0 0;
    }
    .training_content h2, .training_content h3 {
        font-size: 24px;
    }
    .starter_inner_level, .free_trials_lead .lead_inner {
        max-width: calc(100%/1);
    }
    .every_ravel_inner h2 {
        font-size: 32px;
    }
    .free_trial_butt{
        font-size: 20px;
    }
    .tvi_member_include_white_bg h2 {
        font-size: 21px;
    }
}

@media screen and (max-width:481px){
    .price_inner {
        max-width: calc(100%/1);
        margin-bottom: 25px;
    }
    .banner_partts h1 {
        font-size: 40px;
    }
    .sub_heading h2 {
        font-size: 30px;
        padding: 0 20px;
    }
    .travel_container2{
        padding: 5px 20px;
    }
    .travel_container h2, .travel_container2 h2 {
        font-size: 28px;
    }
    .travel_cont_para p {
        font-size: 16px;
        line-height: 22px;
    }
    .vacation_player > div{
        height: 100% !important;
    }
    .ready_started{
        padding: 0 10px;
        font-size: 16px;
    }
    .unlock_tools_inner h2 {
        font-size: 26px;
        line-height: 32px;
    }
    .unlock_tools_cont p {
        font-size: 18px;
        line-height: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/signup/plan_new.css"],"names":[],"mappings":"AAAA;IACI,6DAA0D;IAC1D,4BAA4B;IAC5B,+BAA+B;IAC/B,sBAAsB;AAC1B;;;AAGA;IACI,6DAA6D;IAC7D,4BAA4B;IAC5B,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;;IAEhD,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gDAAgD;AACpD;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uCAAuC;IACvC,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C;IAC1C,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;IAC/B,kCAAkC;IAClC,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,oCAAoC;QACpC,2BAA2B;IAC/B;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,oCAAoC;QACpC,2BAA2B;IAC/B;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,oCAAoC;QACpC,2BAA2B;IAC/B;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,oCAAoC;QACpC,0BAA0B;IAC9B;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gDAAgD;AACpD;AACA;IACI,uCAAuC;IACvC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wEAAgE;IAChE,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;GAEG;;;AAGH;IACI,6DAAiE;IACjE,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,0DAA6D;IAC7D,sBAAsB;IACtB,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gDAAgD;AACpD;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6DAAiE;IACjE,sBAAsB;IACtB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,gDAAgD;AACpD;AACA;IACI,kBAAkB;IAClB,gDAAgD;AACpD;AACA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,WAAW;IACX,6DAAuD;IACvD,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;AACV;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,wBAAwB;IACxB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,WAAW;AACf;;;AAGA;IACI,0CAA0C;IAC1C,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,6DAA4D;IAC5D,sBAAsB;IACtB,+BAA+B;IAC/B,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,4BAA4B;IAC5B,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,0CAA0C;IAC1C,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,0CAA0C;IAC1C,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,mCAAmC;IACnC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,6DAA2D;IAC3D,sBAAsB;IACtB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gDAAgD;AACpD;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB,iBAAiB;IACjB;IACA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;QACvB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,eAAe;QACf,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".full_bg{\n    background: url(../../assets/images/full_bg.png) no-repeat;\n    background-attachment: fixed;\n    background-position: center top;\n    background-size: cover;\n}\n\n\n.banner_partts{\n    background: url(../../assets/images/banner_img.png) no-repeat;\n    background-attachment: fixed;\n    padding: 30px 0;\n    width: 100%;\n    background-size: cover;\n}\n\n.banner_partts h1{\n    font-size: 72px;\n    color: #fff;\n    line-height: 1.3em;\n    text-align: center;\n    font-family: 'Montserrat', sans-serif !important;\n    \n    margin-bottom: 0px;\n}\n.banner_partts h1 strong{\n    display: block;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.sub_heading{\n    padding-top: 42px;\n    max-width: 990px;\n    margin: 0 auto;\n    width: 100%;\n}\n.sub_heading h2{\n    font-size: 46px;\n    font-weight: 400;\n    color: #fff;\n    text-shadow: 1px 1px 3px rgba(0,0,0,.5);\n    text-align: center;\n    margin-bottom: 0px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.cup_coffee{\n    display: block;\n}\n\n.free_trial_butt{\n    height: 50px;\n    padding: 0 40px;\n    line-height: 50px;\n    background: #107faa;\n    display: inline-block;\n    font-family: 'Abel', sans-serif !important;\n    color: #fff;\n    font-size: 26px;\n    font-weight: 700;\n    margin-top: 0;\n    text-shadow: 0 0 0 transparent;\n    animation: bounce 1.5s infinite;\n    animation-timing-function: ease-in;\n    transition: .2s;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.free_trial{\n    text-align: center;\n    margin-top: 30px;\n}\n\n.free_trial a:hover{\n    color: #fff;\n    text-decoration: none;\n}\n\n@keyframes bounce{\n    15% {\n        box-shadow: 0 0 0 0 transparent;\n        transform: translateY(0);\n    }\n    35% {\n        box-shadow: 0 8px 5px -5px #00000040;\n        transform: translateY(-35%);\n    }\n    45% {\n        box-shadow: 0 0 0 0 transparent;\n        transform: translateY(0);\n    }\n    55% {\n        box-shadow: 0 5px 4px -4px #00000040;\n        transform: translateY(-20%);\n    }\n    70% {\n        box-shadow: 0 0 0 0 transparent;\n        transform: translateY(0);\n    }\n    80% {\n        box-shadow: 0 4px 3px -3px #00000040;\n        transform: translateY(-10%);\n    }\n    90% {\n        box-shadow: 0 0 0 0 transparent;\n        transform: translateY(0);\n    }\n    95% {\n        box-shadow: 0 2px 3px -3px #00000040;\n        transform: translateY(-2%);\n    }\n    99% {\n        box-shadow: 0 0 0 0 transparent;\n        transform: translateY(0);\n    }\n    100% {\n        box-shadow: 0 0 0 0 transparent;\n        transform: translateY(0);\n    }\n}\n\n.free_trials_lead{\n    display: flex;\n    flex-wrap: wrap;\n    margin: 30px -10px;\n}\n\n.lead_inner{\n    max-width: calc(100%/3);\n    width: 100%;\n    text-align: center;\n    padding: 0 10px;\n}\n.lead_inner img{\n    width: 200px;\n    height: 200px;\n}\n.lead_heading{\n    margin-top: 30px;\n    background: rgba(45, 45, 45, 0.5);\n    width: 100%;\n    padding: 5px 0;\n}\n.lead_heading h2{\n    font-size: 32px;\n    font-weight: 700;\n    color: #fff;\n    margin-bottom: 0px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.lead_para{\n    background-color: rgba(45, 45, 45, 0.5);\n    padding: 5px;\n    margin-top: 10px;\n}\n\n.lead_para p{\n    font-family: 'Abel', sans-serif !important;\n    color: #fff;\n    font-size: 22px;\n    margin-bottom: 0px;\n    /* font-family: 'Montserrat', sans-serif !important; */\n}\n\n.tripvalet_logo{\n    text-align: center;\n}\n\n.tripvalet_logo img{\n    width: 200px;\n}\n\n.vacation_incentive{\n    background: url(../../assets/images/bg.png) no-repeat center top;\n    background-size: cover;\n    padding: 30px 0;\n}\n\n.vacation_inner h2{\n    text-align: center;\n    font-size: 32px;\n    color: #fff;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.vacation_player iframe{\n    width: 100% !important;;\n    height: 100% !important;;\n}\n\n/* .vacation_player > div{\n    width: 100% !important;\n} */\n\n\n.gift_of_travel{\n    background: url(../../assets/images/gift_of_travel.png) no-repeat;\n    background-size: cover;\n    background-position: center top;\n    background-attachment: fixed;\n    padding: 100px 0;\n}\n\n.travel_container{\n    background: rgba(0, 0, 0, 0.5);\n    padding: 5px 0;\n    width: 100%;\n    margin-bottom: 50px;\n}\n.travel_container2{\n    background: rgba(0, 0, 0, 0.5);\n    padding: 5px 60px;\n    width: 100%;\n}\n.travel_container h2, .travel_container2 h2{\n    text-align: center;\n    color: #fff;\n    font-weight: 700;\n    font-size: 42px;\n    margin-bottom: 0px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.travel_container p{\n    font-size: 23px;\n    font-weight: 500;\n    color: #fff;\n    text-align: center;\n    margin-bottom: 0px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.travel_cont_para p{\n    font-size: 23px;\n    font-weight: 500;\n    color: #fff;\n    margin-bottom: 0px;\n    text-align: center;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.every_one_travel{\n    background: url(../../assets/images/travelll_bggg.png) repeat;\n    background-size: cover;\n    background-position: 50%;\n    background-attachment: fixed;\n    padding: 60px 0;\n}\n\n.every_ravel_inner h2{\n    font-weight: 700;\n    color: #fff;\n    font-size: 58px;\n    text-align: center;\n    margin-bottom: 40px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.free_trial_butt.color2{\n    background: rgb(11, 92, 123);\n}\n.tvi_member_include{\n    background: url(../../assets/images/member_include.png) no-repeat;\n    background-size: cover;\n    background-position: center center;\n    padding: 30px 0;\n}\n\n.tvi_member_include_white_bg{\n    background: #fff;\n    padding: 20px 25px;\n}\n\n.tvi_member_include_white_bg h2{\n    text-align: center;\n    color: #000;\n    font-weight: 700;\n    font-size: 32px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.tvi_member_para p{\n    font-size: 23px;\n    line-height: 32px;\n    text-align: center;\n    color: #000;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.tvi_member_para p span{\n    display: block;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.tvi_member_border_cont{\n    border: 2px solid #000;\n    padding: 20px;\n    text-align: left;\n}\n\n.tvi_member_border_cont ul{\n    padding-left: 0px;\n    margin-bottom: 0px;\n}\n\n.tvi_member_border_cont ul li{\n    list-style: none;\n    position: relative;\n    padding-left: 40px;\n}\n.tvi_member_border_cont ul li, .tvi_member_border_cont ul li p{\n    font-size: 20px;\n    color: #000;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.tvi_member_border_cont ul li p{\n    margin-bottom: 0px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.tvi_member_border_cont ul li p{}\n.tvi_member_border_cont ul li:before{\n    position: absolute;\n    content: \"\";\n    background: url(../../assets/images/tick.png) no-repeat;\n    width: 32px;\n    height: 32px;\n    left: 0;\n    top: 0;\n}\n\n.monthly_price{\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -10px;\n}\n\n.price_inner{\n    padding: 0 10px;\n    max-width: calc(100%/3);\n    width: 100%;\n    margin-top: 15px;\n}\n\n.price_inner_inner{\n    border: 2px solid #fff;\n    padding: 20px;\n}\n\n.price_inner_inner h2{\n    font-size: 32px;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 9px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.price_inner_inner h3{\n    font-size: 32px;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 0px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.price_inner_heading{\n    min-height: 115px;\n}\n\n.price_button{\n    margin-top:30px;\n    text-align: center;\n}\n\n.get_started_but{\n    font-family: 'Abel', sans-serif !important;\n    color: rgb(16, 127, 170);\n    background: #fff;\n    padding: 0;\n    font-weight: 700;\n    height: 60px;\n    line-height: 60px;\n    font-size: 26px;\n    display: block;\n    width: 100%;\n}\n\n\n.price_inner_heading p{\n    font-family: 'Abel', sans-serif !important;\n    color: #fff;\n    font-size: 14px;\n    text-align: center;\n    margin-bottom: 0px;\n}\n\n.monthly_price{\n    margin-top: 20px;\n}\n\n\n.follow_up_inner{\n    background: url(../../assets/images/follow_up.png) no-repeat;\n    background-size: cover;\n    background-position: center top;\n    padding: 30px;\n}\n\n\n.follow_up_inner h2{\n    text-align: center;\n    color: #fff;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 1.3em;\n    margin-bottom: 35px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.follow_up_inner h3{\n    font-weight: 700;\n    font-size: 24px;\n    color: #FFF;\n    margin: 40px 0 30px 0;\n    text-align: center;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.testimonial_inner{\n    margin-top: 40px;\n}\n\n.test_inner_imgg{\n    margin-bottom: 40px;\n}\n\n.testimonial_inner2{\n    margin-top: 40px;\n}\n\n.faq_inner{\n    background: url(../../assets/images/faq_banner.png) no-repeat;\n    background-attachment: fixed;\n    background-position: 50%;\n    background-size: cover;\n    padding: 30px;\n    margin-top: 40px;\n}\n\n\n.faq_hading{\n    text-align: center;\n}\n\n.faq_hading h2{\n    padding: 0 40px;\n    display: inline-block;\n    color: rgb(16, 127, 170);\n    font-size: 38px;\n    font-weight: 700;\n    border-bottom: 4px solid rgb(16, 127, 170);\n    padding-bottom: 10px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.faq_inner_section{\n    margin-top: 40px;\n}\n.faq_content{\n    margin-bottom: 30px;\n}\n\n.question_faq{\n    font-size: 23px;\n    font-weight: 500;\n    color: rgb(43, 143, 192);\n    text-align: center;\n    line-height: 32px;\n    margin-bottom: 15px;\n}\n\n\n.answer_faq{\n    font-size: 20px;\n    font-family: 'Abel', sans-serif !important;\n    color: #fff;\n    line-height: 30px;\n    text-align: center;\n}\n.answer_faq span{\n    text-transform: uppercase;\n}\n\n.faq_bulb{\n    text-align: center;\n    margin-top: 30px;\n}\n.faq_bulb img{\n    width: 80px;\n}\n\n.get_started_div{\n    text-align: center;\n}\n\n.ready_started{\n    font-family: 'Abel', sans-serif !important;\n    background-color: rgb(16, 127, 170);\n    color: #fff;\n    font-size: 40px;\n    font-weight: 700;\n    height: 80px;\n    line-height: 80px;\n    padding: 0 35px;\n    display: inline-block;\n    border: 0px;\n}\n\n.unlock_tools{\n    margin-top: 30px;\n    background: url(../../assets/images/tools_bg.png) no-repeat;\n    background-size: cover;\n    background-position: center top;\n    padding: 60px 0;\n}\n\n.unlock_tools_inner h2{\n    font-size: 48px;\n    font-weight: 700;\n    color: #000;\n    text-align: center;\n    line-height: 56px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.unlock_tools_cont p{\n    font-size: 32px;\n    font-weight: 500;\n    color: #fff;\n    line-height: 46px;\n    text-align: center;\n    margin-bottom: 50px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.business_heading{\n    display: block;\n}\n\n.unlock_tools_cont{\n    margin-top: 30px;\n}\n\n.designed_a_z{\n    padding: 60px 0;\n}\n\n.designed h2{\n    font-size: 52px;\n    font-weight: 700;\n    color: #000;\n    text-align: center;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.designed h2 span{\n    color: rgb(16, 127, 170);\n    line-height: 1.3em;\n    display: block;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.designed h5{\n    text-align: center;\n    font-size: 23px;\n    color: #000;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.starter_level{\n    display: flex;\n    flex-wrap: wrap;\n    margin: 40px -15px 50px -15px;\n}\n\n.starter_inner_level{\n    max-width: calc(100%/3);\n    width: 100%;\n    padding: 0 15px;\n}\n\n.starter_inner_inner_level img{\n    width: 300px;\n    margin: 20px auto;\n    display: block;\n}\n\n.starter_inner_level h2{\n    text-align: center;\n    font-size: 23px;\n    font-weight: 500;\n    color: #000;\n    text-transform: uppercase;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.starter_inner_level p{\n    font-size: 16px;\n    font-family: 'Abel', sans-serif !important;\n    color: #000;\n    text-align: center;\n    margin-top: 30px;\n    padding: 0 20px;\n}\n\n\n.training_content h2{\n    font-size: 32px;\n    color: rgb(45, 45, 45);\n    text-align: center;\n    line-height: 1.3em;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n\n.training_content h3{\n    font-size: 32px;\n    font-weight: 700;\n    color: #000;\n    text-align: center;\n    margin-top: 15px;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.footer_partts{\n    background: rgb(136, 136, 136);\n    padding: 20px 0;\n}\n\n.footer_inner_logo img{\n    width: 200px;\n}\n\n.footer_right_text{\n    max-width: 220px;\n    width: 100%;\n}\n\n.footer_right_text p{\n    color: #fff;\n    font-size: 16px;\n    text-align: center;\n    font-family: 'Abel', sans-serif !important;\n}\n.privacy_div a{\n    font-size: 11px;\n    color: #fff;\n    padding: 0 8px;\n    position: relative;\n}\n.privacy_div a:before{\n    content: \"|\";\n    position: absolute;\n    right: 0;\n    top: 0;\n    color: #fff;\n}\n\n.privacy_div a:last-child:before{\n    content: none;\n}\n\n@media screen and (max-width:576px){\n    .footer_partts{\n        text-align: center;\n    }\n    .footer_right_text{\n        max-width: 100%;\n    }\n}\n\n\n@media screen and (max-width:992px){\n    .banner_partts h1{\n        font-size: 50px;\n    }\n    .sub_heading h2{\n        font-size: 40px;\n        padding: 0 40px;\n    }\n    .free_trials_lead{\n        justify-content: center;\n        align-items: center;\n    }\n    .free_trials_lead .lead_inner{\n        max-width: calc(100%/2);\n    }\n    .lead_inner img {\n        width: 120px;\n        height: 120px;\n    }\n\n    .lead_inner{\n        margin-bottom: 30px;\n    }\n    .vacation_inner h2{\n        font-size: 24px;\n    }\n\n    .vacation_player > div{\n        height: 300px !important;\n    }\n    .gift_of_travel{\n        padding: 40px 0;\n    }\n    .travel_container h2, .travel_container2 h2{\n        font-size: 32px;\n    }\n    .travel_container p{\n        font-size: 18px;\n    }\n    .travel_cont_para p{\n        font-size: 18px;\n        line-height: 24px;\n    }\n\n    .every_one_travel{\n        padding: 20px 0;\n    }\n    .every_ravel_inner h2{\n        font-size: 46px;\n    }\n\n    .tvi_member_include_white_bg h2{\n        font-size: 28px;\n    }\n\n    .tvi_member_para p{\n        font-size: 18px;\n    }\n\n    .tvi_member_border_cont ul li, .tvi_member_border_cont ul li p{\n        font-size: 16px;\n    line-height: 28px;\n    }\n    .price_inner{\n        max-width: calc(100%/2);\n        margin-bottom: 25px;\n    }\n    .follow_up_inner h2{\n        font-size: 26px;\n    }\n\n    .unlock_tools_inner h2{\n        font-size: 32px;\n        line-height: 42px;\n    }\n    .unlock_tools_cont p{\n        font-size: 28px;\n        line-height: 42px;\n    }\n\n    .designed h2{\n        font-size: 32px;\n    }\n\n    .starter_inner_level{\n        max-width: calc(100%/2);\n    }\n    .starter_level{\n        justify-content: center;\n        align-items: flex-start;\n    }\n\n    .training_content h2, .training_content h3{\n        font-size: 28px;\n    }\n}\n\n\n@media screen and (max-width:576px){\n    .ready_started{\n        font-size: 28px;\n        height: 60px;\n        line-height: 60px;\n    }\n    .unlock_tools_cont p {\n        font-size: 24px;\n        line-height: 36px;\n    }\n    .starter_inner_inner_level img{\n        width: 200px;\n    }\n    .designed h2 {\n        font-size: 28px;\n    }\n    \n    .designed_a_z{\n        padding: 30px 0 0 0;\n    }\n    .training_content h2, .training_content h3 {\n        font-size: 24px;\n    }\n    .starter_inner_level, .free_trials_lead .lead_inner {\n        max-width: calc(100%/1);\n    }\n    .every_ravel_inner h2 {\n        font-size: 32px;\n    }\n    .free_trial_butt{\n        font-size: 20px;\n    }\n    .tvi_member_include_white_bg h2 {\n        font-size: 21px;\n    }\n}\n\n@media screen and (max-width:481px){\n    .price_inner {\n        max-width: calc(100%/1);\n        margin-bottom: 25px;\n    }\n    .banner_partts h1 {\n        font-size: 40px;\n    }\n    .sub_heading h2 {\n        font-size: 30px;\n        padding: 0 20px;\n    }\n    .travel_container2{\n        padding: 5px 20px;\n    }\n    .travel_container h2, .travel_container2 h2 {\n        font-size: 28px;\n    }\n    .travel_cont_para p {\n        font-size: 16px;\n        line-height: 22px;\n    }\n    .vacation_player > div{\n        height: 100% !important;\n    }\n    .ready_started{\n        padding: 0 10px;\n        font-size: 16px;\n    }\n    .unlock_tools_inner h2 {\n        font-size: 26px;\n        line-height: 32px;\n    }\n    .unlock_tools_cont p {\n        font-size: 18px;\n        line-height: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
